module.exports = __webpack_public_path__ + "img/dashimg02.e2c3cdc8.png";